// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/purchase_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsPurchaseNames } from "./constants";
import type { PurchaseNamesResult } from "./types";

const DEFAULT_ITEM_LIMIT = 250;

export const getPurchaseNames = reactQueryFetcherAdapter(
  appsAppGroupIdChartsPurchaseNames,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string | undefined,
    limit = DEFAULT_ITEM_LIMIT
  ): Promise<PurchaseNamesResult> => {
    return fetch(`/apps/${appGroupId}/charts/purchase_names`, "GET", { limit, query }, { signal });
  }
);
